// /hooks/useMask.js

import {
  maskCEP,
  maskPhone,
  maskEmail,
  maskNumber,
  maskName,
  maskCPF,
  maskCNPJ
} from "../utils/masks";

export const useMask = () => {
  const applyMask = (type, value) => {
    const masks = {
      cep: maskCEP,
      phone: maskPhone,
      email: maskEmail,
      number: maskNumber,
      name: maskName,
      cpf: maskCPF,
      cnpj: maskCNPJ
    };

    return masks[type] ? masks[type](value) : value;
  };

  return { applyMask };
};
